import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next'

class ModalConfirmPassword extends Component {
    constructor() {
        super();

        this.state = {
            newPassword: '',
            confirmPassword: '',
            oldPassword: ''
        };

    }

    componentWillUnmount() {
        this.setState({
            newPassword: '',
            confirmPassword: '',
            oldPassword: ''
        });
    }

    onChangePassword(e) {
        this.setState({newPassword: e.target.value});
    }

    onChangeConfirmPassword(e) {
        this.setState({confirmPassword: e.target.value});
    }

    onChangeOldPassword(e) {
        this.setState({oldPassword: e.target.value});
    }

    render() {
        const { onClickCancelChangePassword, onClickConfirmChangePassword, t } = this.props;
        const { newPassword, confirmPassword, oldPassword } = this.state;

        return (
            <div className="modal-confirm" style={{display:'block'}} >
                <div className="modal-dialog modal-dialog-centered" style={{ top: -200}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title custom_align" id="Heading">{t('เปลี่ยนรหัสผ่าน')}</h6>
                            <button onClick={() => onClickCancelChangePassword(false)} type="button" className="close"  style={{padding:0,margin:0,position:'inherit'}} data-dismiss="modal" aria-hidden="true"><span className="fa fa-times" aria-hidden="true" /></button>
                        </div>

                        <div className="modal-body">
                            <div className="form-group">
                                <h6>{t('รหัสผ่านใหม่')}</h6>
                            <input className={`form-control required ${newPassword.length > 0 ? '' : 'error'}`} onChange={(e) => this.onChangePassword(e)} type="password" placeholder="" />
                                <br />
                                <h6>{t('ยืนยันรหัสผ่าน')}</h6>
                            <input className={`form-control required ${confirmPassword.length > 0 ? '' : 'error'}`} onChange={(e) => this.onChangeConfirmPassword(e)} type="password" placeholder="" />
                                <br />
                                <h6>{t('รหัสผ่านเดิม')}</h6>
                            <input className={`form-control required ${oldPassword.length > 0 ? '' : 'error'}`} onChange={(e) => this.onChangeOldPassword(e)} type="password" placeholder="" />
                            </div>
                        </div>

                        <div className="modal-footer ">
                            <button className="btn btn-primary" onClick={() => onClickConfirmChangePassword(oldPassword, newPassword, confirmPassword)}>{t('ตกลง')}</button>
                            <button className="btn btn-danger" onClick={() => onClickCancelChangePassword(false)} >{t('ยกเลิก')}</button>
                        </div>
                    </div>
                    {/* /.modal-content */}
                </div>
            </div>
        )
    }
}


ModalConfirmPassword.propTypes = {
    onClickConfirmChangePassword: PropTypes.func.isRequired,
    onClickCancelChangePassword: PropTypes.func.isRequired
}

export default withNamespaces('Menubar')(ModalConfirmPassword)



// WEBPACK FOOTER //
// ./src/app/view/Modals/ModalConfirmPassword.js